import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flight"}/>
}
